import { c as _c } from "react/compiler-runtime";
import React, { useEffect } from 'react';
import { useMediaQuery } from '@shape-construction/hooks/src/useMediaQuery';
import toast, { Toaster as ReactHotToastToaster, useToasterStore } from 'react-hot-toast';
import { breakpoints } from '../utils/breakpoints';
import { ToastPortal } from './ToastPortal';
export const Toaster = t0 => {
  const $ = _c(11);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = breakpoints.up("sm");
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const isLargeScreen = useMediaQuery(t1);
  const {
    toasts
  } = useToasterStore();
  const TOAST_LIMIT = isLargeScreen ? 5 : 2;
  let t2;
  let t3;
  if ($[3] !== TOAST_LIMIT || $[4] !== toasts) {
    t2 = () => {
      toasts.filter(_temp).filter((_, i) => i >= TOAST_LIMIT).forEach(_temp2);
    };
    t3 = [toasts, TOAST_LIMIT];
    $[3] = TOAST_LIMIT;
    $[4] = toasts;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  useEffect(t2, t3);
  const t4 = isLargeScreen ? "bottom-right" : "bottom-center";
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      duration: 6000
    };
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== props || $[9] !== t4) {
    t6 = <ToastPortal><ReactHotToastToaster position={t4} reverseOrder={false} toastOptions={t5} {...props} /></ToastPortal>;
    $[8] = props;
    $[9] = t4;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  return t6;
};
function _temp(t) {
  return t.visible;
}
function _temp2(t_0) {
  return toast.dismiss(t_0.id);
}